import React from 'react'

import {
  Button,
  ColorInput,
  type ColorInputProps,
  ColorPicker,
  ColorSwatch,
  type ColorSwatchProps,
  Popover,
  Stack,
  UnstyledButton,
  type UnstyledButtonProps,
} from '@mantine/core'

import { BLACKISH_TEXT } from '#theme/colors'

interface ColorSwatchPickerProps extends ColorInputProps {
  swatchProps?: Partial<ColorSwatchProps>
  targetProps?: Partial<UnstyledButtonProps>
}

export const ColorSwatchPicker = (props: ColorSwatchPickerProps) => {
  const displayColor = props.value ?? BLACKISH_TEXT

  return (
    <Popover width={280}>
      <Popover.Target>
        <UnstyledButton aria-label="Edit color" {...props.targetProps}>
          <ColorSwatch radius={4} color={displayColor} {...props.swatchProps} />
        </UnstyledButton>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="xs">
          <ColorPicker
            format="hex"
            value={displayColor}
            onChange={props.onChange}
            w="100%"
          />
          <ColorInput
            label="Selected color"
            value={displayColor}
            onChange={props.onChange}
            withPicker={false}
            withEyeDropper={false}
            pb="sm"
          />
          <Button variant="outline" disabled>
            Reset to default
          </Button>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  )
}
